import { useState, useRef } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../../Base/Services/ToastService";
// import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";

// ------------------ CONSULTAS A LA API--------------------------
import { DetallesIngresosBodega } from "../../../../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";

const RequisasOverlayPanel = ({
  setNuevaFila,
  close,
  selectedPcs,
  setSelectedPCs,
  verificarCampos,
  habilitar,
  MateriaPrima
}) => {
  const lo = useRef(null);
  const toast = useRef(null);
  // const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [ingresosBodega, setIngresosBodega] = useState([]);
  const esMateriaPrima = MateriaPrima === 1 || MateriaPrima === true;

  const openOver = (e) => {
    lo.current.toggle(e);
    setLoading(true);
    fetchData();
  };

  const fetchData = async () => {
    try {
     const response = await DetallesIngresosBodega();

      const esModuloMateriaPrima = MateriaPrima === 1 || MateriaPrima === true;

      const data = response.filter((item) => {
        const idCategoria = Number(
          item?.IdCategoria ?? item?.IdCategory
        );

        const nombreCategoria = String(
          item?.NombreCategoria || ""
        )
          .trim()
          .toLowerCase();

        const esProductoMateriaPrima =
          idCategoria === 1 ||
          nombreCategoria === "materia prima";

        return esModuloMateriaPrima
          ? esProductoMateriaPrima
          : !esProductoMateriaPrima;
      });

      setIngresosBodega(data);
      setLoading(false);
    } catch (error) {
      toastShow(
        toast,
        "error",
        "Error",
        "Hubo un problema al Llamar a la API."
      );
    }
  };

  const AsignarInformacion = () => {
    if (verificarCampos()) {
      setNuevaFila(selectedPcs);
      lo.current.hide();
    }else{
      lo.current.hide();
    }
  };

  const columns = [
    {
      header: "Código",
      headerEn: "Code",
      field: "CodigoProducto",
      className: 'Xsmall',
    },
    {
      header: "Producto",
      headerEn: "Product",
      field: "NombreProducto",
      flex: 1,
      minWidth: 200,
    },
    {
      header: "Tipo Producto",
      headerEn: "Product Type",
      field: "NombreCategoria",
      className: 'medium',
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: 'medium',
    },
    {
      header: "Sub Categoría",
      headerEn: "Sub Category",
      field: "NombreTipoProducto",
      className: 'medium',
    },
    {
      header: "Bodega",
      headerEn: "Werehouse",
      field: "NombreBodega",
    },
    {
      header: esMateriaPrima ? "Pacas Disponibles" : "Inventario",
      headerEn: esMateriaPrima ? "Available Bales" : "Inventory",
      field: esMateriaPrima ? "InventarioPacas" : "Inventario",
      Format: esMateriaPrima ? "Right" : "Currency",
      Sumary: "sum",
      className: "Xsmall",
    },
  ];

  const table = {
    Data: ingresosBodega,
    selected: selectedPcs,
    setSelected: setSelectedPCs,
    Columns: columns,

    onRowClicked: (event) => {
      setSelectedPCs([event.data]);
    },
  };

  return (
    <div>
      <div className="p-inputgroup mx-2" style={{ width: 250 }}>
        <Button
          label="Agregar Productos"
          onClick={() => AsignarInformacion()}
          disabled={!selectedPcs || selectedPcs?.length === 0}
        />
        <Button
          icon="pi pi-angle-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => openOver(e)}
          disabled={!habilitar}
        />
      </div>
      <OverlayPanel ref={lo} showCloseIcon dismissable={false} onHide={close}>
        <Loader querySelector="FacturasPagoCliente" />
        <div style={{ height: "55vh", width: "70vw" }} id="FacturasPagoCliente">
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default RequisasOverlayPanel;
